import { Id } from '@vimeo/core/types/generic';

export const localStorageConfig = {
  FEATURE: {
    USE_RTC_PERFORMANCE_TOOLS: 'LSC.LIVE.USE_RTC_PERFORMANCE_TOOLS',
    USE_TEST_VIDEOS_SEARCH: 'LSC.LIVE.USE_TEST_VIDEOS_SEARCH',
    USE_MOBILE_ACCESS: 'LSC.LIVE.USE_MOBILE_ACCESS',
    USE_MULTIPLE_AUDIO_TRACKS_IN_RTMP_PREVIEW: 'LSC.LIVE.USE_MULTIPLE_AUDIO_TRACKS_IN_RTMP_PREVIEW',
  },
  DEBUG: {
    SECTION_FILTER: 'LSC.DEBUG.SECTION_FILTER',
    LOGGING: 'LSC.DEBUG.LOGGING',
    FILE_LOGGING: 'LSC.DEBUG.FILE_LOGGING',
    BP_TRACKING_LOGGING: 'LSC.DEBUG.BP_TRACKING_LOGGING',
    AGORA_STATS_COLLECTING: 'LSC.DEBUG.AGORA_STATS_COLLECTING',
    DATADOG_TRACKING_LOGGING: 'LSC.DEBUG.DATADOG_TRACKING_LOGGING',
    API_TRACKING_LOGGING: 'LSC.DEBUG.API_TRACKING_LOGGING',
    EMBED_MESSAGING_ACTIONS_LOGGING: 'LSC.DEBUG.EMBED_MESSAGING_ACTIONS_LOGGING',
    FB_ACTIONS_LOGGING: 'LSC.DEBUG.FB_ACTIONS_LOGGING',
    FB_SDK_LOGGING: 'LSC.DEBUG.FB_SDK_LOGGING',
    INTERVALS_DEBUG_ENABLED: 'LSC.DEBUG.INTERVALS_DEBUG_ENABLED',
    ENABLED: 'LSC.DEBUG.ENABLED',
  },
  LIVE: {
    AGORA_LOG_LEVEL: 'LSC.LIVE.AGORA_LOG_LEVEL',
    AGORA_DISABLE_WEB_AUDIO: 'LSC.LIVE.AGORA_DISABLE_WEB_AUDIO',
    AGORA_LOG_UPLOAD: 'LSC.LIVE.AGORA_LOG_UPLOAD',
    AGORA_AUDIO_HARD_MUTE: 'LSC.LIVE.AGORA_AUDIO_HARD_MUTE',
    AGORA_VIDEO_HARD_MUTE: 'LSC.LIVE.AGORA_VIDEO_HARD_MUTE',
    COMBINED_PROVIDERS: 'LSC.LIVE.COMBINED_PROVIDERS',
    PREFERRED_ENCODER_MODE: 'LSC.SETTINGS.PREFERRED_ENCODER_MODE',
  },
  GRAPHICS: {
    BACKGROUND_LAST_COLOR: 'LSC.GRAPHICS.BACKGROUND_LAST_COLOR',
    IS_CACHING_LOG_ENABLED: 'LSC.GRAPHICS.IS_CACHING_LOG_ENABLED',
    IS_PRELOAD_ENABLED: 'LSC.GRAPHICS.IS_PRELOAD_ENABLED',
    PRELOAD_CONCURRENT_DOWNLOADS_LIMIT: 'LSC.GRAPHICS.PRELOAD_CONCURRENT_DOWNLOADS_LIMIT',
    PRELOAD_CACHED_ITEMS_LIMIT: 'LSC.GRAPHICS.PRELOAD_CACHED_ITEMS_LIMIT',
  },
  MEDIA: {
    /**
     * Agora SDK.
     */
    AGORA_SDK_MEDIA_MODE: 'LSC.LIVE.AGORA_SDK_MEDIA_MODE',
    AGORA_SDK_SCREEN_MODE: 'LSC.LIVE.AGORA_SDK_SCREEN_MODE',
    AGORA_SDK_CLOUD_PROXY: 'LSC.LIVE.AGORA_SDK_CLOUD_PROXY',
    /**
     * Stream.
     */
    STREAM_HEIGHT: 'LSC.MEDIA.STREAM_HEIGHT',
    STREAM_WIDTH: 'LSC.MEDIA.STREAM_WIDTH',
    STREAM_ASPECT_RATIO: 'LSC.MEDIA.STREAM_ASPECT_RATIO',
    STREAM_FRAMERATE: 'LSC.MEDIA.STREAM_FRAMERATE',
    STREAM_BITRATE_MAX: 'LSC.MEDIA.STREAM_STREAM_BITRATE_MAX',
    STREAM_BITRATE_MIN: 'LSC.MEDIA.STREAM_STREAM_BITRATE_MIN',
    STREAM_OPTIMIZATION_MODE: 'LSC.MEDIA.STREAM_OPTIMIZATION_MODE',
    STREAM_CODEC: 'LSC.MEDIA.CODEC',
    /**
     * Screen.
     */
    SCREEN_OPTIMIZATION_MODE: 'LSC.MEDIA.SCREEN_OPTIMIZATION_MODE',
    SCREEN_ENCODER_PRESET: 'LSC.MEDIA.SCREEN_ENCODER_PRESET',
    SCREEN_SVC_PRESET: 'LSC.MEDIA.SCREEN_SVC_PRESET',
    /**
     * Dual stream.
     */
    DUAL_STREAM_MEDIA_ENABLED: 'LSC.DS_MEDIA_ENABLED',
    DUAL_STREAM_SCREEN_ENABLED: 'LSC.DS_SCREEN_ENABLED',
    LOW_STREAM_HEIGHT: 'LSC.MEDIA.LOW_STREAM_HEIGHT',
    LOW_STREAM_WIDTH: 'LSC.MEDIA.LOW_STREAM_WIDTH',
    LOW_STREAM_FRAMERATE: 'LSC.MEDIA.LOW_STREAM_WIDTH',
    LOW_STREAM_BITRATE: 'LSC.MEDIA.LOW_STREAM_BITRATE',
    /**
     * Audio.
     */
    AUDIO_DISCONTINUOUS_TRANSMISSION: 'LSC.AUDIO.DTX',
    AUDIO_NOISE_SUPPRESSION: 'LSC.AUDIO.NSP',
    AUDIO_ECHO_CANCELLATION: 'LSC.AUDIO.ECL',
    AUDIO_AUTO_GAIN: 'LSC.AUDIO.AUG',
    AUDIO_STEREO: 'LSC.AUDIO.STEREO',
    AUDIO_BITRATE: 'LSC.AUDIO.BITRATE',
    AUDIO_SAMPLE_RATE: 'LSC.AUDIO.SAMPLE_RATE',
    AUDIO_SAMPLE_SIZE: 'LSC.AUDIO.SAMPLE_SIZE',
    AUDIO_MIXING_MODE: 'LSC.AUDIO.MIXING_MODE',
    AUDIO_VOLUME_CHECK_THRESHOLD: 'LSC.AUDIO.AUDIO_VOLUME_CHECK_THRESHOLD',
    /**
     * Devices.
     */
    ACTIVE_VIDEO_DEVICE_ID: 'LSC.MEDIA.ACTIVE_VIDEO_DEVICE_ID',
    ACTIVE_VIDEO_DEVICE_STATE: 'LSC.MEDIA.ACTIVE_VIDEO_DEVICE_STATE',
    ACTIVE_AUDIO_DEVICE_ID: 'LSC.MEDIA.ACTIVE_AUDIO_DEVICE_ID',
    ACTIVE_AUDIO_DEVICE_STATE: 'LSC.MEDIA.ACTIVE_AUDIO_DEVICE_STATE',
    /**
     * Room volume.
     */
    ROOM_VOLUME_CHECK_THROTTLE: 'LSC.MEDIA.ROOM_VOLUME_CHECK_THROTTLE',
    ROOM_VOLUME_CHECK_INTERVAL: 'LSC.MEDIA.ROOM_VOLUME_CHECK_INTERVAL',
    /**
     * Other.
     */
    REMOTE_STREAM_FALLBACK_OPTION: 'LSC.RS_FALLBACK_OPTION',
    MIRRORING_ENABLED: 'LSC.MEDIA.MIRRORING_ENABLED',
    BLUR_ENABLED: 'LSC.MEDIA.BLUR_ENABLED',
  },
  MARKETING: {
    QNA_UPSELL: 'LSC.MARKETING.QNA_UPSELL',
    HOW_GO_LIVE_NOTICE: 'LSC.MARKETING.HOW_GO_LIVE_NOTICE',
    STREAMING_4K_UPSELL: 'LSC.MARKETING.STREAMING_4K_UPSELL',
    MULTI_TRACK_INFO_NOTICE: 'LSC.MARKETING.MULTI_TRACK_INFO_NOTICE',
  },
  INTERACTION: {
    /**
     * @param id - the interaction room id
     * @returns key for storage of jwt with auth preferences for preserve anonymous login
     */
    SAVED_USER_AUTH_PREFERENCES(id: Id): string {
      return `LSC.INTERACTION.SAVED_USER_AUTH_PREFERENCES.${id}`;
    },
  },
};
